"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateArticle = exports.getArticle = exports.getNews = void 0;
const _ = require("lodash");
const getNews = async (supabase) => {
    const { data, error } = await supabase
        .from("news")
        .select(`*`)
        .order("created_at", { ascending: false });
    if (!error) {
        data.map((article) => {
            article.images = JSON.parse(article.images);
            return article;
        });
        return data;
    }
    return error;
};
exports.getNews = getNews;
const getArticle = async (supabase, id) => {
    const { data, error } = await supabase
        .from("news")
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .eq("id", id)
        .single();
    if (!error)
        return data;
    return error;
};
exports.getArticle = getArticle;
const updateArticle = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    if (user?.id) {
        updateObj.modified_by = user?.id;
    }
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    const { data, error } = await supabase
        .from("news")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateArticle = updateArticle;
